import { render, staticRenderFns } from "./DashboardSPKBGenerated.vue?vue&type=template&id=b56c9366&"
import script from "./DashboardSPKBGenerated.vue?vue&type=script&lang=js&"
export * from "./DashboardSPKBGenerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports